import DataItem from "../../../../cmpts/dataStats/DataItem";
import FunnelLadderGroup from "../../../../cmpts/dataStats/FunnelLadderGroup";
import React from 'react'
import 'moment/locale/zh-cn';
import {Button, Col, Message, Row, Table, Tooltip, Select} from "antd";
import ladderImg from '../../../../../images/market/groupBuy/groupBuyLadder.svg'
import Util from "../../../../public/utils";
import moment from 'moment'
import TaskpostExplain from "../../../prizeunlock/activity_explain";
import Api from "../../../../public/api";
import {
    URL_MXD_GROUPBUY_STATS_LADDAR_DATA_EXPORT,
    URL_MXD_GROUPBUY_STATS_NORMAL_DATA_EXPORT
} from '../../../../public/variables'
import Price from "../../../prizeunlock/common/Price";
import ZkSearchGroup from "../../../../common/search/zkSearchGroup";
import ZkSelect from "../../../../common/search/zkSelect";
import ZkSelectDateRange from "../../../../common/search/zkSelectDateRange";
import Store from "../../../../store";

const Option = Select.Option;

const DataKeys = {
    pv: 'pv',
    uv: 'uv',
    amount: 'amount',//营销支付金额，订单金额总和
    discount: 'discount',//优惠金额
    amountRate: 'amountRate',// 费效比
    shareCustomer: 'shareCustomer',//发起分享用户数
    scanJoinCustomer: 'scanJoinCustomer',//扫码并下单
    scanCustomer: 'scanCustomer',//分享访客数
    successCustomer: 'successCustomer',
    discounted: 'discounted',
    joinCustomer: 'joinCustomer',//参与用户数joinCustomer
    sucessRate: 'sucessRate',
    takeRate: 'takeRate',
    orderNum: 'orderNum',
    successOrderNum: 'successOrderNum',

    payUserNum: 'payUserNum',//付费用户数
    payedAmount: 'payedAmount',//营销支付金额，订单金额总和
    takeRates: 'takeRates',//转化率，付费用户数/售前访客数（PV）
    returnAmount: 'returnAmount',//返佣金额，单位分
    earnings: 'earnings',//收益，单位分
    statDate: 'statDate',//统计时间 例子：2020-03-01 00:00
    // scanCustomer: 'scanCustomer',//扫码用户数

    shareUv: 'shareUv',//分享访客数

};

const DataItemMetaData = {
    [DataKeys.pv]: {
        labelText: '浏览量(PV)',
        unitText: '次',
        tooltip: '筛选时间内，该活动页被访问的次数',
        circleColor: "#0C8EFF"
    },
    [DataKeys.uv]: {
        labelText: '访客数(UV)',
        unitText: '人',
        tooltip: '筛选时间内，该活动页被访问的人数',
        circleColor: "#F6BD15"
    },
    [DataKeys.discount]: {
        labelText: '营销优惠金额',
        unitText: '元',
        tooltip: '筛选时间内，该活动商品订单优惠金额之和',
        circleColor: "#0C8EFF"
    },
    [DataKeys.amount]: {
        labelText: '营销支付金额',
        unitText: '元',
        tooltip: '筛选时间内，该活动商品所有成功支付订单金额之和',
        circleColor: "#FF9D4D"
    },
    [DataKeys.amountRate]: {
        labelText: '费效比',
        unitText: '%',
        tooltip: '筛选时间内， 该活动商品费效比=营销支付金额 / 营销优惠金额',
        circleColor: "#6CC8EC"
    },
    [DataKeys.returnAmount]: {
        labelText: '返现金额',
        unitText: '元',
        tooltip: '筛选时间内，该活动商品成功支付订单返现金额之和',
        circleColor: "#F6BD15"
    },
    [DataKeys.earnings]: {
        labelText: '收益金额',
        unitText: '元',
        tooltip: '筛选时间内，该活动商品收益金额=营销支付金额-返现金额',
        circleColor: "#FD7D15"
    },
    [DataKeys.shareCustomer]: {
        labelText: '发起分享人数',
        unitText: '人',
        tooltip: '筛选时间内，该活动商品点击发起分享的人数',
        circleColor: "#FF9D4D"
    },
    [DataKeys.scanJoinCustomer]: {
        labelText: '分享参团数',
        unitText: '人',
        tooltip: '筛选时间内，通过分享参与拼团活动下单人数',
        circleColor: "#5D7092"
    },
    [DataKeys.scanCustomer]: {
        labelText: '分享访客数(UV)',
        unitText: '人',
        tooltip: '筛选时间内，通过分享访问该活动商品页面的人数',
        circleColor: "#6CC8EC"
    },
    [DataKeys.discounted]: {
        labelText: '营销优惠金额',
    },
    [DataKeys.successCustomer]: {
        labelText: '成团人数',
        unitText: '人',
        tooltip: '筛选时间内，参与该活动商品下单成团人数',
        circleColor: "#9270CA"
    },
    [DataKeys.joinCustomer]: {
        labelText: '拼团人数',
        unitText: '人',
        tooltip: '筛选时间内，参与该活动商品拼团人数',
        circleColor: "#F6BD15"
    },
    [DataKeys.sucessRate]: {
        labelText: '拼团成团转化率',
        unitText: '%',
        tooltip: '筛选时间内，该活动商品成团率=成团人数 / 访客数(UV)',
        circleColor: "#6CC8EC"
    },
    [DataKeys.takeRate]: {
        labelText: '成团率',
        unitText: '%',
        tooltip: '筛选时间内，该活动商品拼团成团转化率=成团人数 / 拼团人数',
        circleColor: "#6CC8EC"
    },
    [DataKeys.orderNum]: {
        labelText: '拼团订单',
        unitText: '单',
        // tooltip: '筛选时间内，该活动用户下单的订单数',
        circleColor: "#6CC8EC"
    },
    [DataKeys.successOrderNum]: {
        labelText: '成团订单',
        unitText: '单',
        // tooltip: '筛选时间内，该活动用户下单的订单数',
        circleColor: "#6CC8EC"
    },

    [DataKeys.notJoinNum]: {
        labelText: '未参与活动人数',
        unitText: '人',
        tooltip: '筛选时间内，该活动未参与解锁礼包人数',
        circleColor: "#6CC8EC"
    },
    [DataKeys.notInvtNum]: {
        labelText: '参与未邀请人数',
        unitText: '人',
        tooltip: '筛选时间内，参与该活动已解锁礼包，但未邀请好友解锁的人数',
        circleColor: "#9270CA"
    },
    [DataKeys.invtNotFinish]: {
        labelText: '邀请未完成人数',
        unitText: '人',
        tooltip: '筛选时间内，参与该活动已解锁礼包，邀请好友但未解锁成功的人数',
        circleColor: "#6CC8EC"
    },
    [DataKeys.unlockAllBag]: {
        labelText: '总解锁人数',
        unitText: '人',
        tooltip: '筛选时间内，已解锁礼包总人数(如果一人解锁多级，则按一人统计)',
        circleColor: "#F6BD15"
    },
    [DataKeys.globalTransRatio]: {
        labelText: '全局转化率',
        unitText: '%',
        tooltip: '筛选时间内，该活动全局数据，指所有访客进入页面的平均转化率=订单数/访客数(UV)',
        circleColor: "#E8684A"
    },
    [DataKeys.distriTransRatio]: {
        labelText: '分销转化率',
        unitText: '%',
        tooltip: '筛选时间内，通过分享扫码进入活动页面的订单转化率=分销订单数/分销访客数(UV)',
        circleColor: "#36FD15"
    },
    [DataKeys.orderNum]: {
        labelText: '订单数',
        unitText: '单',
        tooltip: '筛选时间内，该活动用户下单的订单数',
        circleColor: "#6CC8EC"
    },
    [DataKeys.distriOrder]: {
        labelText: '分销订单数',
        unitText: '单',
        tooltip: '筛选时间内，该活动用户通过分销下单的订单数',
        circleColor: "#FF9E4D"
    },
    [DataKeys.distriUv]: {
        labelText: '分销访客数',
        unitText: '人',
        tooltip: '筛选时间内，通过分享访问该活动页面的人数',
        circleColor: "#E8684A"
    },
    [DataKeys.joinNum]: {
        labelText: '参与解锁礼包人数',
        unitText: '人',
        tooltip: '',
        circleColor: "#E8F84A"
    },
};

/**
 * 数据分析
 */

let arr = 'general_group_activity_data'
let arr1 = 'general_group_activity_data1'
let currentPageNum=1

class ActivityData extends React.Component {
    constructor(props) {
        super(props);
        this.getTimeVal = this.getTimeVal.bind(this);
        this.initSelectData = this.initSelectData.bind(this);
        this.queryParamsChange = this.queryParamsChange.bind(this);
        this.timeSelect = this.timeSelect.bind(this);
        this.getTableData = this.getTableData.bind(this);
        this.state = {
            activeTab: 0,
            ladderLevel: 0,
            bodyData: {
                groupbuyId: Util.getActivityId() == 0 ? -1 : Util.getActivityId(),
                timeType: 0, //0:今日、1昨日、2:最近7天，3最近30天，4自定义
                startTime: new Date().getTime(),
                endTime: ''
            },
            showYD: true,//展示昨日数据
            statData: [],
            searchItemList: [],
            //    筛选字段
            chartTimeDay: "今日",
            key: ['pv', 'uv', 'successCustomer', 'amount', 'discounted'],
            defauktTrend: [
                {
                    name: '浏览量(PV)',
                    key: 'pv'
                }, {
                    name: '访客数(UV)',
                    key: 'uv'
                }, {
                    name: '成团人数',
                    key: 'successCustomer'
                }, {
                    name: '营销支付金额',
                    key: 'amount'
                }, {
                    name: '营销优惠金额',
                    key: 'discounted'
                }
            ],
            checkeddefauktTrend: [0],
            activityList: []
            // selector: JSON.parse(this.props.selector),

        };
        this.defaultLadderData = {
            pv: 0, //浏览量
            uv: 0, //访客数
            orderNum: 0, //分销订单
            payUserNum: 0, //付费用户数
            distriTransRatio: 0, //分销订单转化率
        };
        this.defaultOperation = {
            uv: 0,
            pv: 0,
            amount: 0,
            discount: 0,
            amountRate: 0,
        };
        this.defaultTotalData = {
            pv: 0,
            uv: 0,
            payUserNum: 0,//付费用户数
            payedAmount: 0,//营销支付金额，订单金额总和
            takeRates: 0,//转化率，付费用户数/售前访客数（PV）
            returnAmount: 0,//返佣金额，单位分
            earnings: 0,//收益，单位分
            shareCustomer: 0,//发起分享用户数
            joinCustomer: 0,//参与用户数
            shareUv: 0,//分享访客数
        };
        this.defaultNoYday = {
            amount: 0,//营销支付金额，订单金额总和
            discount: 0,//优惠金额
            amountRate: 0,// 费效比
            shareCustomer: 0,//发起分享用户数
            scanJoinCustomer: 0,//扫码并下单
            scanCustomer: 0,//分享访客数
        };
        this.defaultPanelLadder = {
            joinCustomer: 0,
            successCustomer: 0,
            sucessRate: 0,
            takeRate: 0,
            ladderLevel: 0,
        };
    }

    componentWillMount() {
        // let str = Store.getQueryParams(arr)
        // let str1 = Store.getQueryParams(arr1)
        // if(this.props.groupBooktype == 'common'){
        //     if(str && str.params){
        //         this.setState({
        //             bodyData:str.params
        //         })
        //     }
        //     if(str && str.pageNum){
        //         currentPageNum = str.pageNum
        //     }
        // }else if(this.props.groupBooktype == 'isCommon'){
        //     if(str1 && str1.params){
        //         this.setState({
        //             bodyData:str1.params
        //         })
        //     }
        //     if(str1 && str1.pageNum){
        //         currentPageNum = str1.pageNum
        //     }
        // }


        if (this.props.location && this.props.location.query) {
            let groupbuyId = this.props.location.query.id;
            let bodyData = this.state.bodyData;
            bodyData.groupbuyId = groupbuyId;
            this.setState({
                bodyData: bodyData
            });
            this.getDataList(bodyData);
        } else {
            this.getDataList();
        }
        this.initSelectData();
        let allPanelData = Object.assign(this.defaultOperation, this.defaultNoYday);
        this.transAllPanelData(allPanelData, this.state.bodyData, {});
    }

    componentDidMount() {
        this.chart = echarts.init(document.getElementById('puTrendChart'), 'zikun');
        var chart = this.chart;
        $(window).resize(function () {
            chart.resize();
        });
    }

    getDataList(body) {
        let bodyData = body ? body : this.state.bodyData;
        Api.getGroupBuyAllData(this.props.type, bodyData, (data) => {
            this.transPanelLadder(data);
            let allPanelData = Object.assign(data.marketingData, data.otherData);
            this.transAllPanelData(allPanelData, this.state.bodyData, data.ydayData);
            this.transLadderData(data); // 阶梯图

            this.setState({
                data: data.listData //table 分页专用数据
            });
            this.initTable(data.listData, bodyData.timeType); // table 表格
            this.initChart(data.listData, bodyData.timeType); //折线图

        })
    }

    transAllPanelData(data, params, yDayData) { // yDayDate
        let dataYDay = [];
        if (yDayData && yDayData != {} && yDayData.marketingData && yDayData.otherData) {
            dataYDay = Object.assign(yDayData.marketingData, yDayData.otherData)
        }
        let timeType = params.timeType;
        let showYD = false;
        if (timeType == 0) { //
            showYD = true;
        }
        let operationList = this.defaultOperation;
        let operationData = this.transDataInfo(data, operationList, dataYDay, showYD); //  operationData
        let defaultNoYdayList = this.defaultNoYday;
        let defaultNoYday = this.transDataInfo(data, defaultNoYdayList, [], false); // defaultNoYDay
        this.setState({
            showYD: showYD,
            operationData: operationData,
            defaultNoYday: defaultNoYday,
        });
    }

    transPanelLadder(data) {
        let timeType = this.state.bodyData.timeType;
        let showYD = false;
        if (timeType == 0) { //今日数据
            showYD = true;
        }
        let defaultList = this.defaultPanelLadder;
        let panelLadderList = [];
        if (this.props.type == 'ladder') {
            let ladderGroupData = data.ladderGroupData;
            let yDayData = data.ydayData && data.ydayData.ladderGroupData ? data.ydayData.ladderGroupData : [];
            for (var i = 0; i < ladderGroupData.length; i++) {
                let item = ladderGroupData[i];
                let list = this.transDataInfo(item, defaultList, yDayData, showYD);
                panelLadderList[item.ladderLevel] = list;
            }
        } else {
            let groupData = data.groupData;
            let yDayData = data.ydayData && data.ydayData.groupData ? data.ydayData.groupData : [];
            let list = this.transDataInfo(groupData, defaultList, yDayData, showYD);
            panelLadderList[this.state.ladderLevel] = list;
        }
        this.setState({
            panelLadderList: panelLadderList
        })
    }

    transDataInfo(data, defaultList, yDayData, showYD) {
        let statDataInfo = {};
        for (let dataKey in DataKeys) {
            for (let key in defaultList) {
                if (key == dataKey) {
                    if (DataItemMetaData[dataKey]) {
                        statDataInfo[this.getDataItemName(dataKey)] = {
                            labelText: DataItemMetaData[dataKey].labelText,
                            ydLabelText: '昨日' + DataItemMetaData[dataKey].labelText,
                            value: data[dataKey],
                            ydValue: yDayData[dataKey] ? yDayData[dataKey] : 0,
                            unitText: DataItemMetaData[dataKey].unitText,
                            showYD: showYD,
                            tooltip: DataItemMetaData[dataKey].tooltip,
                            circleColor: DataItemMetaData[dataKey].circleColor,
                        };
                    }
                }
            }
        }
        return statDataInfo
    }

    initTable(data, timeType) {
        for (let i = 0; i < data.length; i++) {
            let listItem = data[i];
            if (timeType == 0 || timeType == 1) {
                listItem.time = new Date(listItem.time).format('yyyy-MM-dd hh:mm')
            } else {
                listItem.time = new Date(listItem.time).format('yyyy-MM-dd')
            }
            listItem.key = i;
        }
        this.setState({
            statData: data //table
        });
        var total = data.length;
        var page_size = 10;
        var pages = Math.floor(total / page_size);
        if (total > page_size * pages) {
            pages++;
        }
        var pageNum = 1;
        var list = [];
        var start = total - 1;
        var end = total - page_size - 1;
        if (end < 0) {
            end = -1;
        }
        for (var i = 0; i < total; i++) {
            list.push(data[i]);
        }
        let pagInfo = {
            total: total,
            pages: pages,
            pageSize: page_size,
            pageNum: pageNum
        };
        this.setState({
            pagInfo: pagInfo
        })
        this._getTableData(pagInfo, 1);
    }

    _getTableData(pagInfo, pageNum) {
        var list = [];
        var start = (pageNum - 1) * pagInfo.pageSize;
        var end = pageNum * pagInfo.pageSize;
        if (end > pagInfo.total) {
            end = pagInfo.total
        }
        var currentList = null;
        var now = new Date().getTime();
        var yesterday = new Date(now - 24 * 60 * 60 * 1000).format('yyyy-MM-dd');
        for (var i = start; i < end; i++) {
            list.push(this.state.data[i]);
        }
        for (let j = 0; j < this.state.data.length; j++) {
            if (new Date(this.state.data[j].statDate).format('yyyy-MM-dd') == yesterday) {
                currentList = this.state.data[j];
            }
        }
        pagInfo.pageNum = pageNum;
        this.setState({
            pagInfo: pagInfo,
            list: list,
            currentList: currentList
        })
    }

    timeSelect(type, day) {
        if (type == 'chart') {
            let bodyData = {
                timeType: 0,//0:今日、1昨日、2:最近7天，3最近30天，4自定义
                startTime: '',
                endTime: ''
            };
            this.getDataList(bodyData);
            var text = '今日';
            if (day == 2) {
                text = '全部'
            }
            this.setState({
                chartTimeDay: text
            })
        }
    }

    getTableData(pageNum) {
        this._getTableData(this.state.pagInfo, pageNum);
    }

    //分页页数变化
    pageChange(num) {
        this.getTableData(num)
    }

    // 数据面板 数据处理
    tranStatData(data, params, key, yDayData) {
        let timeType = params.timeType;
        let showYD = false;
        if (timeType == 0 && key != 'defaultNoYday') { //今日数据
            showYD = true;
        }
        let statDataInfo = {};
        let defaultList = [];
        if (key == 'defaultNoYday') {
            defaultList = this.defaultNoYday;
        } else if (key == 'statDataInfo') {
            defaultList = this.defaultTotalData;
        } else {
            defaultList = this.defaultOperation
        }
        for (let dataKey in DataKeys) {
            for (let key in defaultList) {
                if (key == dataKey) {
                    if (DataItemMetaData[dataKey]) {
                        statDataInfo[this.getDataItemName(dataKey)] = {
                            labelText: DataItemMetaData[dataKey].labelText,
                            ydLabelText: '昨日' + DataItemMetaData[dataKey].labelText,
                            value: data[dataKey],
                            ydValue: yDayData ? yDayData[dataKey] : null,
                            unitText: DataItemMetaData[dataKey].unitText,
                            showYD: showYD,
                            tooltip: DataItemMetaData[dataKey].tooltip,
                            circleColor: DataItemMetaData[dataKey].circleColor,
                        };
                    }
                }
            }
        }
        this.setState({
            showYD: showYD,
            [key]: statDataInfo
        });
    }


    // 阶梯组件 数据处理  totalData
    transLadderData(data) {
        let totalData = {
            pv: data.marketingData.pv,
            uv: data.marketingData.uv,
            orderNum: data.otherData.orderNum,
            successOrderNum: data.otherData.successOrderNum,
        };
        if (this.props.type == 'ladder') {
            for (var i = 0; i < data.ladderGroupData.length; i++) {
                let item = data.ladderGroupData[i];
                if (item.ladderLevel == 0) {
                    totalData.joinCustomer = item.joinCustomer;
                    totalData.successCustomer = item.successCustomer;
                    totalData.sucessRate = item.sucessRate;
                    totalData.takeRate = item.takeRate;
                }
            }
        } else {
            totalData.joinCustomer = data.groupData.joinCustomer;
            totalData.successCustomer = data.groupData.successCustomer;
            totalData.sucessRate = data.groupData.sucessRate;
            totalData.takeRate = data.groupData.takeRate;
        }

        // data 需要从各个数据中拿
        let funnelLadderData = {
            itemList: [
                {
                    labelText: DataItemMetaData[DataKeys.pv].labelText,
                    value: totalData[DataKeys.pv]
                },
                {
                    labelText: DataItemMetaData[DataKeys.uv].labelText,
                    value: totalData[DataKeys.uv]
                },
                {
                    labelText: DataItemMetaData[DataKeys.orderNum].labelText,
                    value: totalData[DataKeys.orderNum]
                },
                {
                    labelText: DataItemMetaData[DataKeys.joinCustomer].labelText,
                    value: totalData[DataKeys.joinCustomer]
                },
                {
                    labelText: DataItemMetaData[DataKeys.successOrderNum].labelText,
                    value: totalData[DataKeys.successOrderNum]
                },
                {
                    labelText: DataItemMetaData[DataKeys.successCustomer].labelText,
                    value: totalData[DataKeys.successCustomer]
                }
            ],
            rate1: {
                labelText: '成团率',
                value: this.filterRate(Number(totalData.takeRate)) + '%'
            },
            rate2: {
                labelText: '访客-拼团转化率',
                value: this.getRate(totalData.joinCustomer, totalData.uv) + '%'
            },
            rate3: {
                labelText: '拼团-成团转化率',
                value: this.filterRate(Number(totalData.sucessRate)) + '%'
            },
            ladderImg: ladderImg
        };
        this.setState({
            funnelLadderData: funnelLadderData
        })
    }

    filterRate(n) {
        if (n == -1) {
            return 0
        }
        return n.toFixed(2)
    }

    getRate(n1, n2) {
        if (n2) {
            if (n1 / n2 == 1) {
                return 100
            } else {
                return ((n1 / n2) * 100).toFixed(2);
            }
        }
        return 0;
    }

    /**
     * 初始化搜索框数据
     */
    initSelectData() {
        Api.getGroupBuyActList(this.props.type, (data) => {
            let arr = data.list;
            arr.unshift({
                groupbuyId: -1,
                groupbuyName: '全部活动',
            });
            this.setState({
                activityList: arr
            });
        }, (error) => {
        })
    }

    /**
     * 查询
     * @param params
     */
    queryParamsChange(params) {
        //0:今日、1昨日、2:最近7天，3最近30天，4自定义
        //-1:今日、-2昨日、7:最近7天，30最近30天，0自定义
        let timeRange = params.timeRange;
        if (timeRange.dateRange.length != 2) {
            Message.error('请选择统计时间');
            return
        }
        let bodyData = this.state.bodyData;
        let day = timeRange.dateType;
        bodyData.groupbuyId = params.groupbuyId;
        bodyData.timeType = day == -1 ? 0 : (day == -2 ? 1 : (day == 7 ? 2 : (day == 30 ? 3 : (day == 0 ? 4 : null))));
        bodyData.startTime = timeRange.dateRange[0];
        bodyData.endTime = timeRange.dateRange[1];
        this.setState({
            bodyData: bodyData
        }, () => {
            // if(this.props.groupBooktype == 'common'){
            //     Store.setAddFriendQueryParams(arr,this.state.bodyData,currentPageNum)
            // }else if(this.props.groupBooktype == 'isCommon'){
            //     Store.setAddFriendQueryParams(arr1,this.state.bodyData,currentPageNum)
            // }

            this.getDataList(bodyData);
        });
    }

    /**
     * 导出数据实现
     */
    exportData() {
        let params = this.state.bodyData;
        let arr = [];
        arr.push('groupbuyId=' + params.groupbuyId);
        arr.push('timeType=' + params.timeType);
        arr.push('startTime=' + params.startTime);
        if (params.endTime) {
            arr.push('endTime=' + params.endTime)
        }
        let str = arr.join('&');
        if (this.props.type == 'ladder') {
            Util.downLoadFile(URL_MXD_GROUPBUY_STATS_LADDAR_DATA_EXPORT + '?' + str);
        } else {
            Util.downLoadFile(URL_MXD_GROUPBUY_STATS_NORMAL_DATA_EXPORT + '?' + str);
        }

    }

    reset() { //    重置筛选信息
        let bodyData = {
            groupbuyId: -1,
            timeType: 0,
            startTime: '',
            endTime: ''
        };
        this.setState({
            bodyData: bodyData
        })
        this.getDataList(bodyData);
    }

    getDate(check) {
        let timeRange = this.state.timeRange;
        if (check) {
            if (Util.isNull(timeRange[0])) {
                Message.warning("请选择活动开始时间", null, null, true);
            }
            if (Util.isNull(timeRange[1])) {
                Message.warning("请选择活动结束时间", null, null, true);
            }
            if (timeRange[1] < timeRange[0]) {
                Message.warning("活动结束时间应大于活动开始时间", null, null, true);
            }
            if (timeRange[1].valueOf() <= new Date()) {
                Message.warning("活动结束时间必须晚于现在时间", null, null, true);
            }
        }
        let range = [];
        for (let i = 0; i < timeRange.length; i++) {
            range.push(timeRange[i].valueOf())
        }
        return range;
    }

    getTimeVal(timeId) {
        this.setState({
            timeId: timeId
        });
    }

    disabledDate(current) {
        return current && current > moment().endOf('day');
    }

    // 折线图初始化
    initChart(chartData, timeType) {
        let pv = [];
        let uv = [];
        let discounted = [];
        let amount = [];
        let successCustomer = [];
        let statPeriod = [];

        for (let k = 0; k < chartData.length; k++) {
            uv.push(chartData[k].uv);
            pv.push(chartData[k].pv);
            discounted.push(chartData[k].discounted);
            amount.push(chartData[k].amount);
            successCustomer.push(chartData[k].successCustomer);
            if (timeType == 0 || timeType == 1) {
                // statPeriod.push(new Date(chartData[k].time).format('yyyy-MM-dd hh'));
                statPeriod.push(chartData[k].time);
            } else {
                statPeriod.push(new Date(chartData[k].time).format('yyyy-MM-dd'));
            }
        }
        let key = this.state.key;
        let defauktTrend = this.state.defauktTrend;
        let name = [];
        let series = [
            {
                name: DataItemMetaData[DataKeys.pv].labelText,
                type: 'line',
                data: pv,
                smooth: true
            },
            {
                name: DataItemMetaData[DataKeys.uv].labelText,
                type: 'line',
                data: uv,
                smooth: true
            },
            {
                name: DataItemMetaData[DataKeys.successCustomer].labelText,
                type: 'line',
                data: successCustomer,
                smooth: true
            },
            // {
            //     name: DataItemMetaData[DataKeys.amount].labelText,
            //     type: 'line',
            //     data: amount,
            //     smooth: true
            // },
            // {
            //     name: DataItemMetaData[DataKeys.discounted].labelText,
            //     type: 'line',
            //     data: discounted,
            //     smooth: true
            // }
        ];
        // let selector = this.state.selector;
        for (let i = 0; i < defauktTrend.length; i++) {
            let item = defauktTrend[i];
            name.push(item.name);
        }
        var option = {
            title: {
                text: ''
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: name,
                y: 'top',
                x: 'left'
            },
            grid: {
                left: '0',
                right: '10px',
                top: '50px',
                bottom: '10px',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: statPeriod,
                interval: 0,
            },
            yAxis: {
                type: 'value',
                splitLine: {
                    show: true,
                    lineStyle: {
                        type: 'solid',
                        color: 'rgba(0, 0, 0, 0.15)',
                        width: '1'
                    }
                },
                axisLine: {
                    lineStyle: {
                        type: 'solid',
                        color: 'rgba(0, 0, 0, 0.15)',
                        width: '1'
                    }
                },
            },
            series: series
        };
        this.chart.setOption(option);
    }

    getDataItemName(key) {
        return key + 'DataItem';
    }

    changeTab(tab) {
        this.setState({
            activeTab: tab,
            ladderLevel: tab
        })
    }

    render() {
        const columns = [
            {
                title: "时间",
                dataIndex: 'time',
                key: "time",
                width:'200px',
                fixed: 'left',
                render: (record) => (
                    <span>{record}</span>
                )
            },
            {
                title: () => {
                    return (
                        <div className={'goodsStock'}>
                            <span className={'text'}>浏览量(PV)</span>
                            <Tooltip className={'retailTootip'}
                                     title={TaskpostExplain.getPV()}>
                                <i className="icon-question"></i>
                            </Tooltip>
                        </div>
                    )
                },
                dataIndex: 'pv',
                key: "pv",
            },
            {
                title: () => {
                    return (
                        <div className={'goodsStock'}>
                            <span className={'text'}>访客量(UV)</span>
                            <Tooltip className={'retailTootip'}
                                     title={TaskpostExplain.getUV()}>
                                <i className="icon-question"></i>
                            </Tooltip>
                        </div>
                    )
                },
                dataIndex: 'uv',
                key: "uv",
            },
            {
                title: () => {
                    return (
                        <div className={'goodsStock'}>
                            <span className={'text'}>营销支付金额</span>
                            <Tooltip className={'retailTootip'}
                                     title={TaskpostExplain.getPayedAmount()}>
                                <i className="icon-question"></i>
                            </Tooltip>
                        </div>
                    )
                },
                dataIndex: 'amount',
                key: "amount",
                render: (text) => (
                    <Price price={text}/>
                )
            },
            {
                title: () => {
                    return (
                        <div className={'goodsStock'}>
                            <span className={'text'}>营销优惠金额</span>
                            <Tooltip className={'retailTootip'}
                                     title={TaskpostExplain.getDiscounted()}>
                                <i className="icon-question"></i>
                            </Tooltip>
                        </div>
                    )
                },
                dataIndex: 'discounted',
                key: "discounted",
                render: (text) => (
                    <Price price={text}/>
                )
            },
            {
                title: () => {
                    return (
                        <div className={'goodsStock'}>
                            <span className={'text'}>费效比</span>
                            <Tooltip className={'retailTootip'}
                                     title={TaskpostExplain.getAmountRate()}>
                                <i className="icon-question"></i>
                            </Tooltip>
                        </div>
                    )
                },
                dataIndex: 'amountRate',
                key: "amountRate",
                render: (record) => (
                    <span>{record == -1 ? '-' : record + '%'}</span>
                )
            },
            {
                title: () => {
                    return (
                        <div className={'goodsStock'}>
                            <span className={'text'}>拼团人数</span>
                            <Tooltip className={'retailTootip'}
                                     title={TaskpostExplain.getJoinCustomer()}>
                                <i className="icon-question"></i>
                            </Tooltip>
                        </div>
                    )
                },
                dataIndex: 'joinCustomer',
                key: "joinCustomer",
                render: (record) => (
                    <span>{record}</span>
                )
            }, {
                title: () => {
                    return (
                        <div className={'goodsStock'}>
                            <span className={'text'}>成团人数</span>
                            <Tooltip className={'retailTootip'}
                                     title={TaskpostExplain.getSuccessCustomer()}>
                                <i className="icon-question"></i>
                            </Tooltip>
                        </div>
                    )
                },
                dataIndex: 'successCustomer',
                key: "successCustomer",
                render: (record) => (
                    <span>{record}</span>
                )
            },
            {
                title: () => {
                    return (
                        <div className={'goodsStock'}>
                            <span className={'text'}>拼团成团转化率</span>
                            <Tooltip className={'retailTootip'}
                                     title={TaskpostExplain.getGroupTakeRate()}>
                                <i className="icon-question"></i>
                            </Tooltip>
                        </div>
                    )
                },
                dataIndex: 'takeRate',
                key: "takeRate",
                render: (record) => (
                    <span>{record == -1 ? '-' : record + '%'}</span>
                )
            }, {
                title: () => {
                    return (
                        <div className={'goodsStock'}>
                            <span className={'text'}>成团率</span>
                            <Tooltip className={'retailTootip'}
                                     title={TaskpostExplain.getGroupSucessRate()}>
                                <i className="icon-question"></i>
                            </Tooltip>
                        </div>
                    )
                },
                dataIndex: 'sucessRate',
                key: "sucessRate",
                render: (record) => (
                    <span>{record == -1 ? '-' : record + '%'}</span>
                )
            }
        ];
        return (
            <>
                <ZkSearchGroup ref={r => this.statSearchGroup = r}
                               key={'statQuerySearch'}
                               onOk={this.queryParamsChange.bind(this)}
                               onReset={this.queryParamsChange.bind(this)}
                               otherBtns={<Button onClick={this.exportData.bind(this)}>导出</Button>}>
                    <ZkSelect title={'当前活动：'} valueKey='groupbuyId'
                              defaultValue={this.state.bodyData.groupbuyId}>
                        {
                            this.state.activityList.map((item, key) => {
                                return <Option key={key} value={item.groupbuyId}>{item.groupbuyName}</Option>
                            })
                        }
                    </ZkSelect>
                    <ZkSelectDateRange title={'统计时间：'} valueKey='timeRange'/>
                </ZkSearchGroup>
                <ul className={'mxd-head-flex'}>
                    <li className={'mxd-head-title'}>运营数据</li>
                </ul>
                {
                    this.state.operationData ?
                        <ul className={'data-col-5 back-d2'}>
                            <li className='dataItemWraper'>
                                <DataItem data={this.state.operationData[this.getDataItemName(DataKeys.pv)]}/>
                            </li>
                            <li className='dataItemWraper'>
                                <DataItem data={this.state.operationData[this.getDataItemName(DataKeys.uv)]}/>
                            </li>
                            <li className='dataItemWraper'>
                                <DataItem data={this.state.operationData[this.getDataItemName(DataKeys.amount)]}/>
                            </li>
                            <li className='dataItemWraper'>
                                <DataItem data={this.state.operationData[this.getDataItemName(DataKeys.discount)]}/>
                            </li>
                            <li className='dataItemWraper'>
                                <DataItem data={this.state.operationData[this.getDataItemName(DataKeys.amountRate)]}/>
                            </li>
                        </ul> : ""
                }
                {
                    this.state.panelLadderList ?
                        <>
                            <ul className={'mxd-head-flex'}>
                                <li className={'mxd-head-title'}>拼团数据</li>
                            </ul>
                            {
                                this.props.type == 'ladder' ? <div className={'ladder-tab'}>
                        <span className={this.state.activeTab == 0 ? 'active-tab' : ''}
                              onClick={this.changeTab.bind(this, 0)}>全部</span>
                                    <span className={this.state.activeTab == 1 ? 'active-tab' : ''}
                                          onClick={this.changeTab.bind(this, 1)}>第一阶梯</span>
                                    <span className={this.state.activeTab == 2 ? 'active-tab' : ''}
                                          onClick={this.changeTab.bind(this, 2)}>第二阶梯</span>
                                    <span className={this.state.activeTab == 3 ? 'active-tab' : ''}
                                          onClick={this.changeTab.bind(this, 3)}>第三阶梯</span>
                                </div> : ''
                            }
                            <ul className={'data-col-5'}>
                                <li className='dataItemWraper'>
                                    <DataItem
                                        data={this.state.panelLadderList[this.state.ladderLevel][this.getDataItemName(DataKeys.joinCustomer)]}/>
                                </li>
                                <li className='dataItemWraper'>
                                    <DataItem
                                        data={this.state.panelLadderList[this.state.ladderLevel][this.getDataItemName(DataKeys.successCustomer)]}/>
                                </li>
                                <li className='dataItemWraper'>
                                    <DataItem
                                        data={this.state.panelLadderList[this.state.ladderLevel][this.getDataItemName(DataKeys.sucessRate)]}/>
                                </li>
                                <li className='dataItemWraper'>
                                    <DataItem
                                        data={this.state.panelLadderList[this.state.ladderLevel][this.getDataItemName(DataKeys.takeRate)]}/>
                                </li>
                            </ul>
                        </> : ''
                }
                <ul className={'mxd-head-flex'}>
                    <li className={'mxd-head-title'}>数据详情</li>
                </ul>
                {
                    this.state.defaultNoYday ? <div className={'data-part-panel'}>
                        <div className={'first-part'}>
                            <Row className={'panel-item-three back-d2'}>
                                <Col span={24}>
                                    <p className='qy-circle-title margin-bottom-twenty-one '>投入产出</p>
                                    <Row className={'itemPanel-3'}>
                                        <Col span={8}>
                                            <DataItem
                                                data={this.state.defaultNoYday[this.getDataItemName(DataKeys.amountRate)]}/>
                                        </Col>
                                        <Col span={8}>
                                            <DataItem
                                                data={this.state.defaultNoYday[this.getDataItemName(DataKeys.amount)]}/>
                                        </Col>
                                        <Col span={8}>
                                            <DataItem
                                                data={this.state.defaultNoYday[this.getDataItemName(DataKeys.discount)]}/>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className={'panel-item-three back-d2'}>
                                <Col span={24}>
                                    <p className='qy-circle-title margin-bottom-twenty-one '>销售连带</p>
                                    <Row className={'itemPanel-3'}>
                                        <Col span={8}>
                                            <DataItem
                                                data={this.state.defaultNoYday[this.getDataItemName(DataKeys.shareCustomer)]}/>
                                        </Col>
                                        <Col span={8}>
                                            <DataItem
                                                data={this.state.defaultNoYday[this.getDataItemName(DataKeys.scanCustomer)]}/>
                                        </Col>
                                        <Col span={8}>
                                            <DataItem
                                                data={this.state.defaultNoYday[this.getDataItemName(DataKeys.scanJoinCustomer)]}/>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <Row className={'panel-item-three funnel-panel back-d2'}>
                                <Col span={24}>
                                    <p className='qy-circle-title margin-bottom-thirty-two'>流量转化</p>
                                    <FunnelLadderGroup data={this.state.funnelLadderData}/>
                                </Col>
                            </Row>
                        </div>
                    </div> : ''
                }

                <div className={'data-panel'}>
                    <div className={'dataCount'}>
                        <div className={'dataChart'}>
                            <div id="puTrendChart" className={'trendChart'}></div>
                        </div>
                    </div>
                    <div style={{'height': '15px'}}></div>
                    <div className={'qy-table'}>
                        <Table dataSource={this.state.statData.reverse()}
                               pagination={{
                                   hideOnSinglePage: true,
                                   showQuickJumper: true,
                                   onChange: this.pageChange.bind(this),
                                   total: this.state.pagInfo ? this.state.pagInfo.total : 0,
                                   current: this.state.pagInfo ? this.state.pagInfo.pageNum : 1
                               }}
                               columns={columns}
                               scroll={{x: 1500}}
                        >
                        </Table>
                    </div>
                </div>
            </>
        )
    }

}

export default ActivityData